import { ReactNode } from "react";
import logoVCDB from "../../assets/logo-small-512.png";
import "./LoadingMask.scss";

interface LoadingMaskProps {
  children?: ReactNode;
  message?: string;
}

const LoadingMask: React.FC<LoadingMaskProps> = ({ children, message }) => {
  return (
    <div className="loading-mask">
      <div className="loading-mask-content">
        <img src={logoVCDB} alt="VCDB Logo" />
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default LoadingMask;
